import { Component } from "react";
import { Box, Text } from "@chakra-ui/react";

// [DEBUG] - Remove this file after the removeChild issue is identified
class DebugErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    const label = this.props.label || "Unknown";
    console.group(`[Debug:ErrorBoundary] ❌ Error in <${label}>`);
    console.error("Error:", error.message);
    console.error("Component Stack:", info.componentStack);
    console.error("Full Error:", error);
    console.groupEnd();
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box p={3} border="2px dashed red" borderRadius="md" m={2}>
          <Text color="red.500" fontSize="sm" fontWeight="bold">
            [Debug] Error in &lt;{this.props.label || "Component"}&gt;
          </Text>
          <Text color="red.400" fontSize="xs" mt={1}>
            {this.state.error?.message}
          </Text>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default DebugErrorBoundary;
